// CAR-3630: module-scope guard for the once-per-browser-session full
// calibration-center list fetch owned by PageLayout. PageLayout remounts on every
// authenticated navigation, so this guard prevents a refetch on each page change.
// Only a SUCCESSFUL fetch marks it bootstrapped, so a transient failure retries on
// the next mount.
//
// Lives in its own module (not inside PageLayout) so the logout paths can reset it
// without importing PageLayout — PageLayout imports those components, so the reverse
// import would be circular.
//
// Logout is an SPA navigation (history.push to /authenticate) — it does NOT reload
// the app — so this guard does not clear itself. Every logout path must call
// resetCenterListBootstrap(); otherwise the next login in the same tab skips the
// fetch and leaves the location switcher with only the current center.
let bootstrapped = false
let inFlight = null

export const isCenterListBootstrapped = () => bootstrapped

export const getCenterListInFlight = () => inFlight

export const setCenterListInFlight = (promise) => {
  inFlight = promise
}

export const markCenterListBootstrapped = () => {
  bootstrapped = true
}

export const resetCenterListBootstrap = () => {
  bootstrapped = false
  inFlight = null
}
